import { useRef } from 'react';
import { useFetcher } from 'react-router';
import { phoneNumberSchema, zfd } from '@dinewise/utils';
import { ValidatedForm, withZod } from '@michaelgmcd/rvf';
import * as z from 'zod';
import { Button } from './buttons/index.tsx';
import { PhoneNumberInput } from './fields/input.tsx';
import { ModalOverlay } from './modal.tsx';

export const phoneNumberValidator = withZod(
  z.object({
    phoneNumber: zfd.text(phoneNumberSchema),
  }),
);

type UpdatePhoneNumberModalProps = {
  visible: boolean;
  onCloseHandler: () => void;
};

export const UpdatePhoneNumberModal = ({
  visible,
  onCloseHandler,
}: UpdatePhoneNumberModalProps) => {
  const fetcher = useFetcher();
  const formRef = useRef<HTMLFormElement>(null);
  const isSubmitting = fetcher.state === 'submitting' || fetcher.state === 'loading';

  return (
    <ModalOverlay
      {...{ visible }}
      title="Update Phone Number"
      body={
        <ValidatedForm
          {...{ formRef }}
          validator={phoneNumberValidator}
          className="mx-auto w-full max-w-xl"
        >
          <div className="flex flex-col gap-4 sm:flex-row sm:items-start">
            <PhoneNumberInput
              name="phoneNumber"
              placeholder="Phone Number"
              autoComplete="tel"
              classNames={{ group: 'sm:flex-1' }}
            />
          </div>
          <div className="mt-4 sm:mt-1">
            <span className="text-gray-500 text-xs">
              By providing your mobile number, you agree that it may be used to send you text
              messages and call you to confirm and manage your reservations.
            </span>
          </div>
        </ValidatedForm>
      }
      footer={
        <div className="flex w-full flex-row justify-end">
          <Button
            type="button"
            theme="primary"
            size="md"
            disabled={isSubmitting}
            onClick={() => {
              if (!formRef.current) {
                return;
              }
              fetcher.submit(formRef.current, { method: 'post', action: '/update-phone-number' });
            }}
          >
            {isSubmitting ? 'Saving...' : 'Save'}
          </Button>
        </div>
      }
      onClose={onCloseHandler}
    />
  );
};
